import { inject, Injectable } from '@angular/core';
import { Departures, SalesTypes } from 'app/core/enums/common.enum';
import {
    SalesEndpoints,
    SalesTypeEndpoints,
} from 'app/core/enums/endpoints/inventory.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SalesService {
    private _endpoint = SalesTypeEndpoints;
    private _salesEndpoints = SalesEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------

    validateSales(
        playdateId: number,
        saleType: SalesTypes,
        departure: Departures
    ): Observable<any> {
        const params = this._apiService.buildParams(
            // ['playdate_id', playdateId],
            ['sale_type', saleType.toString()],
            ['departure', departure]
        );

        return this._apiService.getOneWithParam(
            this._salesEndpoints.validateSalesConsistency,
            params,
            playdateId,
            true
        );
    }

    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    /**
     * @description
     * Get all sales types
     * @returns
     */
    getAll(): Observable<any> {
        return this._apiService.get(this._endpoint.getAll);
    }

    /**
     * @description
     * Get single sale type
     * @returns
     */
    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    /**
     * @description
     * Create a new sales type
     * @returns
     */
    create(salesTypeData: any): Observable<any> {
        return this._apiService.post(this._endpoint.create, salesTypeData);
    }

    /**
     * @description
     * Update a sales type
     * @returns
     */
    update(salesTypeData: string, id: number): Observable<any> {
        return this._apiService.update(this._endpoint.patch, salesTypeData, id);
    }

    /**
     * @description
     * Delete a sales type
     * @returns
     */
    delete(id: number): Observable<any> {
        return this._apiService.delete(this._endpoint.delete, id);
    }
}
